<template lang="pug" src="./client-news.pug"></template>
<style lang="scss" src="./client-news.scss" scoped></style>

<script>
import scroll from '@/utils/scroll'

import { mapState, mapGetters } from 'vuex'

export default {
    data: () => ({
        filters: {
            fromDate: null,
            toDate: null,
            shown: null,
            phone: null,
            scope: null
        },
        sorting: {},
        deletingArticle: null,
        deleteDialogOpen: false
    }),
    computed: {
        ...mapGetters(['type', 'permissions']),
        ...mapState({
            articles: state => state.clientNewsView.articles,
            isTableLoad: state => state.clientNewsView.isLoaded,
            pagination: state => state.clientNewsView.pagination,
            appliedFilters: state => state.clientNewsView.filters
        }),
        headers: function() {
            return [
                { text: 'id', value: '"id"' },
                { text: 'header', value: '"header"', sortable: false },
                { text: 'text', value: '"text"', sortable: false },
                { text: 'sendTo', value: '"sendTo"', sortable: false },
                { text: 'status', value: '"status"' },
                { text: 'createdAt', value: '"createdAt"' },
                { text: 'actions', sortable: false }
            ].map(it => Object.assign(it, {
                text: this.$vuetify.t(`$vuetify.pages.ClientNews.table.${it.text}`)
            }))
        }
    },
    watch: {
        sorting: {
            handler() {
                this.getArticlesByPage()
            },
            deep: true
        }
    },
    created: function() {
        this.filters = Object.assign({}, this.appliedFilters)
        this.getArticlesByPage()
    },
    beforeRouteLeave: function(to, from, next) {
        this.$store.commit('clientNewsView/SET_PAGINATION', { page: 1, length: null })
        next()
    },
    methods: {
        openDeleteModal(id) {
            this.deletingArticle = id
            this.deleteDialogOpen = true
        },
        closeDeleteModal() {
            this.deletingArticle = null
            this.deleteDialogOpen = false
        },
        async deleteArticle() {
            await this.$store.dispatch('clientNewsView/dropArticle', this.deletingArticle)

            this.closeDeleteModal()
            this.getArticlesByPage()
        },
        submit() {
            this.$store.commit('clientNewsView/SET_FILTERS', Object.assign({}, this.filters))

            this.getArticlesByPage()
        },
        reset() {
            this.filters = Object.assign({}, {
                fromDate: null,
                toDate: null
            })
            this.$store.commit('clientNewsView/RESET_ARTICLE_FILTERS')
            this.getArticlesByPage()
        },
        getArticlesByPage(page = 1, isScrollEnable = false, excel = false) {
            this.$store.dispatch('clientNewsView/getArticles', {
                excel,
                page,
                column: this.sorting.sortBy,
                direction: this.sorting.descending ? 'desc' : 'asc',
                ...this.appliedFilters
            }).then(_ => {
                if (isScrollEnable) {
                    scroll(this.$refs.table)
                }
            })
        },
        changeToDate(date) {
            this.filters.toDate = date
        },
        changeFromDate(date) {
            this.filters.fromDate = date
        },
        onPageChange(page) {
            if (page !== this.pagination.page) {
                this.getArticlesByPage(page, true)
            }
        },
        addArticle() {
            this.$router.push('/add-client-article')
        },
        openEditor(id) {
            this.$router.push(`client-news/editor/${id}`)
        },
        exportToExcel() {
            this.getArticlesByPage(1, false, true)
        }
    }
}
</script>
